import {scrolEvents} from './default';
import {index} from './index';
import {vues} from './vues';

var ua = window.navigator.userAgent.toLowerCase();
if(ua.indexOf("windows nt") !== -1) {
    document.body.classList.add('windows');
}

document.addEventListener('DOMContentLoaded', function() {
	let scene = [];
	let controller;
    controller =  new ScrollMagic.Controller();
	
	scrolEvents(controller , scene);
    vues();
    index();
});